export const DISTRICTS = [
  { name: "Thiruvananthapuram", slug: "thiruvananthapuram", abbr: "TVM" },
  { name: "Kollam", slug: "kollam", abbr: "KLM" },
  { name: "Pathanamthitta", slug: "pathanamthitta", abbr: "PTA" },
  { name: "Alappuzha", slug: "alappuzha", abbr: "ALP" },
  { name: "Kottayam", slug: "kottayam", abbr: "KTM" },
  { name: "Idukki", slug: "idukki", abbr: "IDK" },
  { name: "Ernakulam", slug: "ernakulam", abbr: "EKM" },
  { name: "Thrissur", slug: "thrissur", abbr: "TSR" },
  { name: "Palakkad", slug: "palakkad", abbr: "PKD" },
  { name: "Malappuram", slug: "malappuram", abbr: "MLP" },
  { name: "Kozhikode", slug: "kozhikode", abbr: "KKD" },
  { name: "Wayanad", slug: "wayanad", abbr: "WYD" },
  { name: "Kannur", slug: "kannur", abbr: "KNR" },
  { name: "Kasaragod", slug: "kasaragod", abbr: "KSD" },
];

export const LOCAL_BODY_TYPES = [
  "Grama Panchayat",
  "Block Panchayat",
  "District Panchayat",
  "Municipality",
  "Corporation",
];

const IMG = (path) => (process.env.PUBLIC_URL || "") + path;

export const COMMITTEE = [
  { name: "Jibin Jose", role: "President", phone: "9747321151", img: IMG("/committee/jibin-jose.jpeg") },
  { name: "Shajeer Hassan", role: "General Secretary", phone: "9809429409", img: IMG("/committee/shajeer-hassan.png") },
  { name: "Najeeb N M", role: "Treasurer", phone: "9605294824", img: IMG("/committee/najeeb-nm.png") },
  { name: "Vishnu V Gopal", role: "Vice President", phone: "8089264337", img: IMG("/committee/vishnu-vgopal.png") },
  { name: "Abdul Rashid K", role: "Vice President", phone: "7736786199", img: IMG("/committee/abdul-rashid-k.jpeg") },
  { name: "Mohammed Azad C", role: "Vice President", phone: "9037004900", img: IMG("/committee/mohammed-azad-c.jpeg") },
  { name: "Thasleem C H", role: "Joint Secretary", phone: "7907924710", img: IMG("/committee/thasleem-ch.png") },
  { name: "Shankar Raveendran", role: "Joint Secretary", phone: "9633257940", img: IMG("/committee/shankar-raveendran.png") },
  { name: "Akhila Soman", role: "Joint Secretary", phone: "7593031957", img: IMG("/committee/akhila-soman.png") },
];

export const SERVICES = [
  { title: "E-Governance Support", desc: "End-to-End Assistance for KSMART, Sulekha, Sevana and other State E-Gov Platforms.", icon: "Network" },
  { title: "Software Administration", desc: "Installation, configuration and maintenance of local body software stacks.", icon: "Server" },
  { title: "Website Management", desc: "Building and maintaining official websites for panchayats, municipalities and corporations.", icon: "Globe" },
  { title: "IT Infrastructure", desc: "LAN, server rooms, backup systems and hardware procurement guidance.", icon: "HardDrive" },
  { title: "Digital Transformation", desc: "Roadmaps for paperless workflows and citizen-facing digital services.", icon: "Sparkles" },
  { title: "Technical Training", desc: "Workshops on Linux, networking, security and modern development practices.", icon: "GraduationCap" },
];
